module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0181.jpg?v=62890295";